/**
 * @file コンポーネント：ログインメニュー DOM管理
 */

// ライブラリ読み込み
import React from "react";

// スタイル読み込み
import {
    StyledLoginmenu,
    StyledLoginmenuAnchor,
    StyledLoginmenuAnchorIcon,
    StyledLoginmenuAnchorText,
    StyledLoginmenuList,
    StyledLoginmenuListItem,
} from "./style";

// Presenterを返す
export const Presenter = (props) => {
    // ローカライズデータ
    const localized = window.listLocalized;

    // ReactDOM
    return (
        <StyledLoginmenu>
            {props.isLogin === true ? (
                // ログイン中
                <StyledLoginmenuList>
                    {/* アカウント */}
                    <StyledLoginmenuListItem>
                        <StyledLoginmenuAnchor
                            className={
                                props.isNotificationAccount === true &&
                                "is-notification"
                            }
                            href={props.isIdentificationUser ? null : "#"}
                            onClick={
                                props.isIdentificationUser
                                    ? undefined
                                    : (e) => {
                                        e.preventDefault();
                                        props.setIsOpenAccountmenu(
                                            !props.isOpenAccountmenu
                                        );
                                    }}
                            ref={props.refButtonAccount}
                            style={{
                                cursor: props.isIdentificationUser
                                    ? "default"
                                    : "pointer",
                                opacity: props.isIdentificationUser
                                    ? 0.5
                                    : 1
                            }}
                        >
                            <StyledLoginmenuAnchorIcon>
                                <i className="fas fa-user"></i>
                            </StyledLoginmenuAnchorIcon>
                            <StyledLoginmenuAnchorText>
                                {localized["Label.Account"]}
                            </StyledLoginmenuAnchorText>
                        </StyledLoginmenuAnchor>
                    </StyledLoginmenuListItem>
                </StyledLoginmenuList>
            ) : (
                // 非ログイン中
                <StyledLoginmenuList>
                    {/* ログイン */}
                    <StyledLoginmenuListItem>
                        <StyledLoginmenuAnchor
                            href="#"
                            onClick={(e) => {
                                e.preventDefault();
                                props.setIsOpenModalLogin(true);
                            }}
                        >
                            <StyledLoginmenuAnchorIcon>
                                <i className="fas fa-sign-in-alt"></i>
                            </StyledLoginmenuAnchorIcon>
                            <StyledLoginmenuAnchorText>
                                {localized["Label.Login"]}
                            </StyledLoginmenuAnchorText>
                        </StyledLoginmenuAnchor>
                    </StyledLoginmenuListItem>
                    {/* 会員登録 */}
                    <StyledLoginmenuListItem>
                        <StyledLoginmenuAnchor href={`/temp-registration/?refPage=${encodeURIComponent(window.location.href)}`}>
                            <StyledLoginmenuAnchorIcon>
                                <i className="fas fa-user-plus"></i>
                            </StyledLoginmenuAnchorIcon>
                            <StyledLoginmenuAnchorText>
                                {localized["Label.Register"]}
                            </StyledLoginmenuAnchorText>
                        </StyledLoginmenuAnchor>
                    </StyledLoginmenuListItem>
                </StyledLoginmenuList>
            )}
        </StyledLoginmenu>
    );
};
